import { Button, ButtonProps, Text, TextProps, VStack } from '@chakra-ui/react'
import { themeColors } from 'theme'

import { IconPropsType } from 'components/SVGS'

interface ButtonBoxProps {
  disabled?: boolean
  icon: React.FC<IconPropsType>
  fill?: string
  secondFill?: string
  isActive?: boolean
  onClick: () => void
  iconSize?: number
  textProps?: TextProps
  buttonProps?: ButtonProps
}

const { customButtons: { bgBorderColor }, icon: { secondaryIconColor } } = themeColors

const ButtonBox: React.FC<ButtonBoxProps> = ({
  children,
  onClick,
  icon: IconCustom,
  disabled,
  iconSize = 10,
  isActive = false,
  fill = bgBorderColor,
  secondFill = secondaryIconColor,
  textProps,
  buttonProps,
}) => {
  return (
    <Button {...buttonProps} isActive={isActive} disabled={disabled} role='group' variant='box' onClick={onClick} >
      <VStack height='full' spacing={1}>
        <VStack flex={0.5} justifyContent='center'>
          <IconCustom fill={disabled || isActive ? 'currentColor' : fill} size={iconSize} secondFill={secondFill} />
        </VStack>
        <VStack flex={0.5} justifyContent='flex-start'>
          <Text
            {...textProps}
            color={isActive ? 'currentcolor' : bgBorderColor}
            _groupHover={{ color: 'currentColor' }}
            whiteSpace='normal'>
            {children}
          </Text>
        </VStack>
      </VStack>
    </Button>
  )
}

export default ButtonBox
